import React, { FC } from 'react'
import MaintenanceGif from 'assets/img/maintenance.gif'
import { ReactComponent as TripleBrandingLogo } from '@obeta/assets/icon/triple-branding-triple-logo.svg'
import { useTranslation } from 'react-i18next'
import { useMaintenanceCheck } from '@obeta/data/lib/hooks'
import { useBusinessLayer } from '@obeta/app-bootstrap'
import { Typography } from '@mui/material'
import { useDisableBodyScroll } from '@obeta/data/lib/hooks/useDisableBodyScroll'
import styles from './Maintenance.module.scss'

type MaintenanceProps = {
  children: React.ReactElement
}

export const Maintenance: FC<MaintenanceProps> = (props) => {
  const { children } = props
  const { t } = useTranslation()

  const { startSync, stopSync } = useBusinessLayer()
  const showMaintenance = useMaintenanceCheck({ startSync, stopSync })

  useDisableBodyScroll(showMaintenance)

  return showMaintenance ? (
    <div className={styles.root}>
      <div className={styles.header}>
        <TripleBrandingLogo className={styles.tripleLogo} />
      </div>
      <div className={styles.content}>
        <div className={styles.textWrapper}>
          <h1 className={styles.header1}>{t('COMMON.MAINTENANCE.TITLE')}</h1>
          <h2 className={styles.header2}>{t('COMMON.MAINTENANCE.SECOND_TITLE')}</h2>
          <div className={styles.subtitle}>
            <Typography className={styles.subtitle} variant="subTitle">
              {t('COMMON.MAINTENANCE.SUBTITLE')}
            </Typography>
          </div>
        </div>

        <div className={styles.maintenanceImageWrapper}>
          <img src={MaintenanceGif} alt={'wartungsarbeit'} className={styles.maintenanceImage} />
        </div>
      </div>
    </div>
  ) : (
    children
  )
}
